import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function FinalCTASection() {
  return <section className="py-24 px-4 bg-gradient-to-b from-cream-100 to-terracotta-50/30" data-id="element-35">
      <div className="max-w-4xl mx-auto text-center" data-id="element-36">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-3xl md:text-5xl font-serif text-brown-800 mb-6" data-id="element-37">
          Empieza hoy <br className="md:hidden" data-id="element-38" />
          <span className="text-terracotta-500" data-id="element-39">
            (sin esperar "el momento perfecto").
          </span>
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-xl text-stone-600 mb-10 max-w-2xl mx-auto" data-id="element-40">
          Si hoy solo das un paso, ya estás más adelante que ayer. Tu propósito
          no se encuentra pensando… se construye haciendo.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} data-id="element-41">
          <Button size="lg" className="text-xl px-12 py-8 shadow-xl" onClick={() => document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-42">
            Sí, lo quiero — $9.99
          </Button>
          <p className="mt-4 text-sm text-stone-500 font-medium" data-id="element-43">
            Descarga inmediata.
          </p>
        </motion.div>
      </div>
    </section>;
}